import React from 'react'

export const AdminCurrencyFormat = ({
  value,
}) => {

  const formatCurrency = (value) => {
    const num = value || 0
    return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }

  return <div style={{ textAlign: 'right' }}>{formatCurrency(value)}</div>
}
